export const AVAILABLE_BUSINESS_BASE_TYPES = [
  'id',
  'it-tax-code',
  'it-vat-code',
  'name',
] as const;

export type BusinessBaseType = (typeof AVAILABLE_BUSINESS_BASE_TYPES)[number];

export const AVAILABLE_BUSINESS_BASE_REQUEST_ORIGINS = ['base', 'full'] as const;

export type BusinessBaseRequestOrigin =
  (typeof AVAILABLE_BUSINESS_BASE_REQUEST_ORIGINS)[number];

export interface MostSearchedBusinessBase {
  type: string;
  value: string;
  searched_count: number;
}

export interface MostSearchedBusinessBaseResponse {
  most_searched: MostSearchedBusinessBase[];
}

export interface MostRequestedBusinessBase {
  origin: BusinessBaseRequestOrigin;
  type: string;
  value: string;
  requested_count: number;
}

export interface MostRequestedBusinessBaseResponse {
  most_requested: MostRequestedBusinessBase[];
}
